import React from "react";
import styled from "styled-components";
import { SortableHandle } from "react-sortable-hoc";

// Locals
import Bars from "./svg/Bars";

const DragHandleStyled = styled.div`
  align-items: center;
  background-color: #dfe6e9;
  border-radius: 4px;
  bottom: 0;
  cursor: move;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 0.5rem;
  position: absolute;
  top: 0;
  width: 2rem;

  svg {
    width: 100%;
  }
`;

const DragHandle = SortableHandle(() => (
  <DragHandleStyled>
    <Bars />
  </DragHandleStyled>
));

export default DragHandle;
